






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components:{ }
})

export default class Outils extends Vue {
  @Prop() title!: string | null;
  @Prop() url!: string | null;
}
